export const AUTH0_CLIENT_ID =
  process.env.AUTH_CLIENT_ID || "dL54fnZPcUegnc01ggMLRKCFWj27glp4";
export const AUTH0_DOMAIN =
  process.env.AUTH_DOMAIN || "dev-xvq4ml7s.eu.auth0.com";
export const AUTH0_AUDIENCE =
  process.env.AUTH_AUDIENCE || "https://api-dev.findr.global";
